
import { computed, defineComponent, nextTick, ref } from 'vue';
import BaseTable from '@/components/BaseTable.vue';
import { useCurrencyOHLCV } from '@/composables/useCurrencyOHLCV';
import { useCurrencyQuote } from '@/composables/useCurrencyQuote';

export default defineComponent({
  components: {
    BaseTable,
  },
  columns: {
    time: {
      name: 'Date',
      align: 'left',
    },
    open: {
      name: 'Open',
      align: 'right',
    },
    high: {
      name: 'High',
      align: 'right',
    },
    low: {
      name: 'Low',
      align: 'right',
    },
    close: {
      name: 'Close',
      align: 'right',
    },
    volumefrom: {
      name: 'Volume From',
      align: 'right',
    },
    volumeto: {
      name: 'Volume To',
      align: 'right',
    },
  },
  props: {
    currencyName: {
      type: String,
      default: '',
    },
    currencySymbol: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { currencyQuote } = useCurrencyQuote();
    const { currencyOHLCV, fetchCurrencyOHLCV, lastTimestamp } =
      useCurrencyOHLCV(30);
    const loadButtonText = ref('Load more');

    const sortedData = computed(() => {
      if (currencyOHLCV.value) {
        return [...currencyOHLCV.value].sort((a, b) => b.time - a.time);
      }
      return null;
    });

    async function loadMore() {
      if (loadButtonText.value === 'Loading...') return;
      loadButtonText.value = 'Loading...';
      const res = await fetchCurrencyOHLCV(
        props.currencySymbol,
        currencyQuote.value,
        10,
        lastTimestamp.value
      );
      currencyOHLCV.value?.push(...res.data);
      lastTimestamp.value = res.lastTs - 60 * 60 * 24;
      loadButtonText.value = 'Load more';
      await nextTick();
      window.scrollTo(0, document.body.scrollHeight);
    }

    return { sortedData, loadMore, loadButtonText };
  },
});
